import './style.scss';

import React, { useState, useEffect, useCallback } from 'react';

import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { useModal } from '@ebay/nice-modal-react';

import { updateConfigHeaderFooter } from '../../../actions';

import ModalSyllabus from 'pctComponents/modals/ModalSyllabus';

import { getLevelNodeEnrollment } from 'services/api';
import { removeTagsHtml, getProfileInfo } from 'services/utils';

import { InteractionDrawer } from 'pctComponents/organisms';
import { DrawerContainer } from 'pctComponents/organisms/InteractionDrawer/InteractionDrawer.types';
import useMediaQuery from 'pctHooks/useMediaQuery';
import AttachmentSideBar from 'pctComponents/organisms/AttachmentSideBar';

import { CreateDrawerContainer } from './components/CreateDrawerContainer';
import { MenuHeaderContentView } from './components/MenuHeaderContentView';
import GenericNotification from 'pctComponents/organisms/PctHeader/components/GenericNotification';

type Props = { nodeCollection: BlockElement; configHeaderFooter: any; };
type collectionProps = { data: DataBlockElement };

const MenuHeaderContent = ({ nodeCollection, configHeaderFooter }: Props) => {
    const isMobile = useMediaQuery('md');
    const userModal = useModal(ModalSyllabus);
    const [collection, setCollection] = useState<collectionProps | null>(null);
    const [drawerContainer, setDawerContainer] = useState<DrawerContainer>({} as DrawerContainer);
    // const [singleLevelContent, setSingleLevelContent] = useState(false);
    const [isOpenComments, setIsOpen] = useState<boolean>(false);
    const [isOpenModalInformation, setIsOpenModalInformation] = useState<boolean>(false);
    const [showInteractionDrawerButton, setShowInteractionDrawerButton] = useState(false);
    const [isOpenAttachmentSideBar, setIsOpenAttachmentSideBar] = useState<boolean>(false);
    const [attachmentStatus, setAttachmentStatus] = useState<null | boolean>(null);
    const [idTeam, setIdTeam] = useState<null | number>(null);
    const [infoConfig, setInfoConfig] = useState<any>(null);
    const [nodeTitle, setNodeTitle] = useState<any>(null);

    const configInfoModalRequiered = useCallback((team, lastAccessDate) => {
        if (!team?.configuration?.commentIsMandatory) {
            return {
                lastAccessDate: '',
                team: {},
                showInformation: false,
            };
        }
        return {
            lastAccessDate: lastAccessDate,
            team: team,
            showInformation: true,
        };
    }, []);

   

    
    useEffect(() => {
        if (nodeCollection && nodeCollection.node) {
            const { allowComments, commentsLabel, nodeCode, nodeEnrollment, title } = nodeCollection.node;

            setNodeTitle(title);

            const commentsObj = {
                node: {
                    allowComments: allowComments || null,
                    commentsLabel: commentsLabel || null,
                    idEntity: `${nodeCode || null}`,
                },
                team: {
                    allowComments: nodeEnrollment?.team?.allowComments || null,
                    commentsLabel: nodeEnrollment?.team?.commentsLabel || null,
                    idEntity: `${nodeEnrollment?.team?.idTeam || null}`,
                },
            };

            const { showInteractionDrawer, drawerContainer } = CreateDrawerContainer(commentsObj, isMobile);
            setShowInteractionDrawerButton(showInteractionDrawer);
            const config = configInfoModalRequiered(nodeEnrollment?.team, nodeEnrollment?.lastAccessDate);
            setInfoConfig(config);

            setIsOpenModalInformation(!config?.lastAccessDate && Boolean(config?.showInformation));
            setDawerContainer(drawerContainer);
            setCollection({ data: nodeCollection.node });
            // setSingleLevelContent(Boolean(nodeCollection.levelSingle)); // Verifica se ocorreu um redirecionamento do level para um conteúdo
            setAttachmentStatus(Boolean(nodeCollection?.node?.nodeEnrollment?.team?.hasAttachments));
            nodeCollection?.node?.nodeEnrollment?.team?.idTeam &&
                setIdTeam(nodeCollection?.node?.nodeEnrollment?.team?.idTeam);
        } else {
            if (configHeaderFooter.single) {
                const contentEnrollment = configHeaderFooter.contentNavigation.contentEnrollment;
                const team = configHeaderFooter.contentNavigation.team[0];
                const nodeCode = team.nodeCode;
                const idTeam = team.idTeam;

                const commentsObj = {
                    node: {
                        allowComments: contentEnrollment.allowCommentsInNode || null,
                        commentsLabel: contentEnrollment.commentsLabelInNode || null,
                        idEntity: `${nodeCode || null}`,
                    },
                    team: {
                        allowComments: team.allowComments || null,
                        commentsLabel: team.commentsLabel || null,
                        idEntity: `${idTeam || null}`,
                    },
                };

                const { showInteractionDrawer, drawerContainer } = CreateDrawerContainer(commentsObj, isMobile);
                setShowInteractionDrawerButton(showInteractionDrawer);
                setDawerContainer(drawerContainer);
                const config = configInfoModalRequiered(team, contentEnrollment?.lastAccessDate);
                const hasAttachments = Boolean(contentEnrollment.hasAttachments);
                setAttachmentStatus(hasAttachments);
                setIdTeam(idTeam);
                setInfoConfig(config);

                setIsOpenModalInformation(!config?.lastAccessDate && Boolean(config?.showInformation));
            }
        }

        return () => {
            setAttachmentStatus(null);
            setIdTeam(null);
            setShowInteractionDrawerButton(false);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [nodeCollection, configHeaderFooter.single, isMobile]);

    // console.log('nodeCollection --> ', nodeCollection);

    const callSyllabus = (e) => {
        e.stopPropagation();
        userModal.show({ collection });
    };

    const syllabusStatus =
        nodeCollection &&
        collection &&
        collection.data.syllabus &&
        removeTagsHtml(collection.data.syllabus).length > 0 &&
        collection.data.nodeType === 'LEARNING';
    const meetingStatus = false;

    // const verifyStatus = !singleLevelContent && (syllabusStatus || meetingStatus || Boolean(showInteractionDrawerButton) || attachmentStatus);
    const verifyStatus = syllabusStatus || meetingStatus || Boolean(showInteractionDrawerButton) || attachmentStatus;

    return verifyStatus ? (
        <div className="menuHeaderContent">
            <MenuHeaderContentView
                syllabusStatus={syllabusStatus}
                callSyllabus={callSyllabus}
                meetingStatus={meetingStatus}
                attachmentStatus={attachmentStatus}
                setIsOpenAttachmentSideBar={setIsOpenAttachmentSideBar}
                showInteractionDrawerButton={showInteractionDrawerButton}
                setIsOpen={setIsOpen}
                setIsOpenModalInformation={setIsOpenModalInformation}
                infoConfig={infoConfig}
            />
            {isOpenComments && (
                <InteractionDrawer
                    {...drawerContainer}
                    isOpen={isOpenComments}
                    configHeaderFooter={configHeaderFooter}
                    handleClose={() => setIsOpen(false)}
                />
            )}
            {attachmentStatus && (
                <AttachmentSideBar
                    idTeam={idTeam}
                    isOpen={isOpenAttachmentSideBar}
                    handleClose={() => setIsOpenAttachmentSideBar(false)}
                />
            )}
            {nodeTitle && <GenericNotification
                open={isOpenModalInformation}
                onClose={() => {
                    setIsOpenModalInformation(false);
                }}
                notificationType={'required-consumption-interaction'}
                notificationData={{
                    title: nodeTitle,
                    customData: {},
                }}
            />}
        </div>
    ) : null;
};

const mapDispatchToProps = (dispatch) => ({
    updateConfigHeaderFooter: (item) => dispatch(updateConfigHeaderFooter(item)),
});

export default compose(withRouter, connect(null, mapDispatchToProps))(MenuHeaderContent);
